import React from 'react';
import IconCardText from '../../../components/IconCardText/IconCardText';
import IconFilled from '../../../components/IconFilled/IconFilled';
import SectionTitle from '../../../components/SectionTitle/SectionTitle';
import './CourseBenefits.css';
import { IconBuilding, IconCertificate, IconUsersGroup, IconUserStar } from "@tabler/icons-react";

const getIconByText = (text) => {
   switch (text) {
      case 'Certificados de Especialización':
         return <IconCertificate className="course-benefits-icon" />;
      case 'Instrucción de Expertos':
         return <IconUserStar className="course-benefits-icon" />;
      case 'Validación de Instituciones Veterinarias':
         return <IconBuilding className="course-benefits-icon" />;
      case 'Comunidad Veterinaria':
         return <IconUsersGroup className="course-benefits-icon" />;
      default:
         return null;
   }
};

export default function CourseBenefits({ benefitsTexts }) {
   const { benefitsInfo, benefitsGeneralInfo } = benefitsTexts;
   const { title, subtitle, textInfo } = benefitsGeneralInfo;

   

   return (
      <div className='course-benefits-container'>
         {benefitsGeneralInfo.show &&
            <div className='course-benefits-heading'>
               <SectionTitle upText={subtitle} downText={title} />
               <p className='course-benefits-description'>{textInfo}</p>
            </div>
         }
         {benefitsInfo.show &&
            <div className='course-benefits-information'>
               {
                  benefitsInfo.content.map((item, idx) => (
                     <IconCardText
                        key={idx} text={item.text}
                        description={item.description}
                        minHeight={184}
                     >
                        <IconFilled
                           backgroundColor='var(--color-primary)'
                           rounded='var(--border-radius-sm)'
                        >
                           {getIconByText(item.text)}
                        </IconFilled>
                     </IconCardText>
                  ))
               }
            </div>
         }
      </div>
   )
}
